import { render, staticRenderFns } from "./plLivePlay.vue?vue&type=template&id=7b15088f&scoped=true"
import script from "./plLivePlay.vue?vue&type=script&lang=js"
export * from "./plLivePlay.vue?vue&type=script&lang=js"
import style0 from "./plLivePlay.vue?vue&type=style&index=0&id=7b15088f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b15088f",
  null
  
)

export default component.exports